import React from 'react';

import { TextContainer } from './TextBlock.styled';

import { TextBlockProps } from './TextBlock.types';

export const TextBlock = ({ text, ...styles }: TextBlockProps) => (
  <TextContainer {...styles}>{text}</TextContainer>
);
